import { useMemo } from "react";

import { useLabels } from "../../contexts/labels";
import { MaterialType } from "../../types/materials";
import { renameFields } from "../../utils/object";
import { EventsLabels } from "./types";

export function useEventsLabels() {
  const { labels: stringLabels } = useLabels();

  const labels = useMemo(
    () =>
      renameFields(stringLabels, {
        materials: "forms-materials",
        [MaterialType.Wood]: "materials-wood",
        [MaterialType.Stone]: "materials-stone",
        [MaterialType.Glass]: "materials-glass",
        [MaterialType.Materia]: "materials-materia",
        [MaterialType.Metal]: "materials-metal",
      }) as EventsLabels,
    [stringLabels]
  );

  return labels;
}
